<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-10">
            <div class="row pt-3 p-sm-3" v-cloak>
                <div class="col-12 col-lg-6">
                    <div class="p-1 p-sm-4">
                        <organization-list-widget
                            :user="user"
                            :user-organizations="userOrganizations"
                        ></organization-list-widget>
                    </div>
                    <div class="p-1 p-sm-4">
                        <team-list-widget
                            :user="user"
                            :organization="organization"
                            :subscription="subscription"
                        ></team-list-widget>
                    </div>
                </div>
                <div class="col-12 col-lg-6">
                    <div class="p-1 p-sm-4">
                        <client-list-widget
                            :user="user"
                            :organization="organization"
                            :organization-clients="organizationClients"
                            :user-org-clients="userOrgClients"
                            @refresh-clients="$emit('refresh-clients')"
                        ></client-list-widget>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import TeamListWidget from "./widgets/TeamListWidget";
import ClientListWidget from "./widgets/ClientListWidget/ClientListWidget";
import OrganizationListWidget from "./widgets/OrganizationListWidget";
import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "Connections",
    props: [
        "user",
        "organization",
        "userOrganizations",
        "subscription",
        "organizationClients",
        "userOrgClients",
    ],
    mixins: [sideMenuItems],
    components: {
        GoLotusSideMenu,
        TeamListWidget,
        ClientListWidget,
        OrganizationListWidget,
    },
    data() {
        return {};
    },
};
</script>

<style scoped></style>
